/**
 * Componente de modal de imagem
 */

import { resolveImageUrl } from "../utils";
import { FiX } from "react-icons/fi";

interface ImageModalProps {
  show: boolean;
  imageUrl: string | null | undefined;
  alt: string;
  onClose: () => void;
}

export function ImageModal({ show, imageUrl, alt, onClose }: ImageModalProps) {
  if (!show || !imageUrl) return null;

  return (
    <div
      className="fixed inset-0 z-[60] flex items-center justify-center bg-slate-950/80 p-4 backdrop-blur-sm"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
    >
      <div
        className="relative max-w-[95vw] max-h-[90vh]"
        onClick={(e) => e.stopPropagation()}
      >
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img
          src={resolveImageUrl(imageUrl)}
          alt={alt}
          className="max-w-[95vw] max-h-[90vh] object-contain rounded-lg shadow-2xl"
        />
        <button
          type="button"
          aria-label="Fechar"
          onClick={onClose}
          className="absolute -right-3 -top-3 flex h-9 w-9 items-center justify-center rounded-full bg-white text-slate-700 shadow-lg transition hover:bg-slate-100 focus:outline-none focus-visible:ring-4 focus-visible:ring-primary-100"
        >
          <FiX aria-hidden="true" />
        </button>
      </div>
    </div>
  );
}
